"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpEmailVerificationWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
exports.SignUpEmailVerificationWrapper = styled_1.default.div `
  padding: 16px;
  * > {
    font-size: 15px;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.8);
  }
  h4 {
    margin-bottom: 10px;
  }
  h5 {
    position: absolute;
    margin-top: 3px;
    font-size: 12px;
  }
`;
